var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115 37.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff2800;}.cls-2{fill:#872821;}.cls-3{fill:#e5b240;}.cls-4{fill:#51717c;}.cls-5{fill:#d96924;}.cls-6{fill:#737320;}.cls-7{fill:#b7a98d;}.cls-8{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.51 15.59 72.03 15.59 57.51 1.06 42.97 15.58 57.51 15.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.81 1.05 16.34 15.59 30.88 15.59 16.34 1.05 1.81 1.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.27,
    y: 18.59,
    width: 14.53,
    height: 14.53,
    transform: "translate(-1.43 48.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.66 1.07 84.14 15.59 98.67 15.59 98.66 1.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "98.67 15.59 113.19 1.07 98.67 1.07 98.67 15.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.53 15.59 98.65 15.59 78.09 36.15 57.53 15.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "16.41 15.59 57.53 15.59 36.97 36.15 16.41 15.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "72.03 15.59 57.51 1.06 42.97 15.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "30.88 15.59 16.34 1.05 1.81 1.05 16.34 15.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "67.81 25.86 57.53 36.13 47.26 25.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 98.66,
    y1: 1.07,
    x2: 84.14,
    y2: 15.59
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "98.67 15.59 113.19 1.07 98.67 1.07 98.67 15.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "57.53 15.59 98.65 15.59 78.09 36.15 57.53 15.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "16.41 15.59 57.53 15.59 36.97 36.15 16.41 15.59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b96cfd9ee70e9cacdeec8b7d814383a.svg";
export { ForwardRef as ReactComponent };